<h2 class="text-start text-5 leading-[30px] font-medium text-content" mat-dialog-title>
  {{ data.title }}
</h2>
<div mat-dialog-content>
  <div class="text-grey-2" id="confirmation-content" [innerHTML]="data.message"></div>
</div>
<div align="center" mat-dialog-actions>
  <button cdkFocusInitial class="action-yes mr-5" mat-flat-button type="button" [mat-dialog-close]="true">
    {{ 'yes' | transloco }}
  </button>
  <button class="action-no button-accent" mat-flat-button type="button" [mat-dialog-close]="false">
    {{ 'no' | transloco }}
  </button>
</div>
